export const MouseButtons = {
  LEFT: 0,
  MIDDLE: 1,
  RIGHT: 2,
} as const;
